
import React from "react";
import "./Certificates.css";

const certificates = [
  {
    id: 1,
    title: "IEC Certificate",
    description:
      "Importer Exporter Code certification for authorized international trade operations.",
    image:
      "https://ik.imagekit.io/bapyu1ycr/common%20assets/dgft.jpg",
  },

  {
    id: 2,
    title: "FSSAI License",
    description:
      "Food Safety and Standards Authority certification ensuring food safety compliance.",
    image:
      "https://ik.imagekit.io/bapyu1ycr/common%20assets/fssailogo.jpg",
  },

  {
    id: 3,
    title: "GST Certificate",
    description:
      "Goods and Services Tax registration for compliant business operations in India.",
    image:
      "https://ik.imagekit.io/bapyu1ycr/common%20assets/gst.jpg",
  },

  {
    id: 4,
    title: "MSME Certificate",
    description:
      "Recognition as a Micro, Small & Medium Enterprise supporting business growth.",
    image:
      "https://ik.imagekit.io/bapyu1ycr/common%20assets/msmelogo.jpg",
  },

  {
    id: 5,
    title: "AD Code Registration",
    description:
      "Authorized Dealer Code registration required for export customs clearance.",
    image:
      "https://ik.imagekit.io/bapyu1ycr/common%20assets/AdCode.png",
  },

  {
    id: 6,
    title: "APEDA Registration",
    description:
      "Agricultural and Processed Food Products Export Development Authority certification.",
    image:
      "https://ik.imagekit.io/bapyu1ycr/common%20assets/apeda.jpg",
  },
];

const Certificates = () => {
  return (
    <div className="certificates-page">

      {/* HERO */}
      <section className="cert-hero">

        <div className="cert-overlay"></div>

        <div className="cert-hero-content">

          <h1>Our Certifications</h1>

          <p>
            Trusted certifications and registrations that strengthen
            our commitment to quality, compliance, and global trade excellence.
          </p>

        </div>

      </section>

      {/* CONTENT */}
      <section className="cert-content">

        <div className="section-title">

          <span>Global Compliance</span>

          <h2>Verified & Certified Export Operations</h2>

          <p>
            Vetrieq follows internationally recognized standards and
            government-authorized certifications to ensure quality,
            transparency, and trust in every export transaction.
          </p>

        </div>

        {/* GRID */}
        <div className="cert-grid">

          {certificates.map((cert) => (
            <div className="cert-card" key={cert.id}>

              <div className="cert-image">

                <img src={cert.image} alt={cert.title} />

              </div>

              <div className="cert-info">

                <h3>{cert.title}</h3>

                <p>{cert.description}</p>

              </div>

            </div>
          ))}

        </div>


      </section>

    </div>
  );
};

export default Certificates;